import { useEffect } from "react";

import { useTechnologyQueryClient } from "./useTechnologyQueryClient";

export default function usePrefetchTechnologiesDescription() {
    const technologyQueryClient = useTechnologyQueryClient();

    useEffect(() => {
        void technologyQueryClient.prefetchDescription();
    }, [technologyQueryClient]);
}
